import { Component, Inject, OnInit } from '@angular/core';
import { PatternAltService } from '../service/pattern-alt.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EditPatternAltitudeComponent } from '../edit-pattern-altitude/edit-pattern-altitude.component';

@Component({
  selector: 'app-delete-pattern-altitude',
  templateUrl: './delete-pattern-altitude.component.html',
  styleUrls: ['./delete-pattern-altitude.component.scss']
})
export class DeletePatternAltitudeComponent implements OnInit {
  patternAltId: number;
  airportId: number;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<EditPatternAltitudeComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _patternAltService: PatternAltService) {
    this.patternAltId = data.patternAltId;
    this.airportId = data.airportId;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._patternAltService.deletePatternAlt(this.airportId, this.patternAltId);
      this.isLoading = false;
      this.close({success: true});
    } catch (e) {
      this.close({success: false});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
